export default "__VITE_ASSET__28107250__"